import { hasRole } from 'utils/functions'
import { SESSION_WELCOME, SESSION_SKIP_WIZARD } from 'utils/constants'

export const miscellaneousRoutes = [
  {
    path: '/bem-vindo',
    name: 'Welcome',
    meta: {
      requiresAuth: true,
      navbarActions: true
    },
    component: () => import(/* webpackChunkName: 'welcome-page' */ 'views/WelcomePage'),
    beforeEnter (to, from, next) {
      if (
        !hasRole('costCenter', 'ROLE_POST_COSTCENTER') ||
        localStorage.getItem(SESSION_WELCOME)
      ) {
        return next({ name: 'Dashboard' })
      }
      next()
    }
  },
  {
    path: '/wizard',
    name: 'Wizard',
    meta: {
      requiresAuth: true,
      noMainMenu: true
    },
    component: () => import(/* webpackChunkName: 'wizard-page' */ 'views/WizardPage'),
    beforeEnter (to, from, next) {
      if (
        !hasRole('employee', 'ROLE_EMPLOYEE_WIZARD') ||
        localStorage.getItem(SESSION_SKIP_WIZARD)
      ) {
        return next({ name: 'Dashboard' })
      }

      return next()
    }
  }
]
